/** @file exportMethods: one puppet's export as zip bytes — the runtime bundle or baked sprite sheets. */
import type { ExportQuery } from '../types/restAdded';
import type { ClientOptions } from './clientOptions';
import { fillPath } from './fillPath';
import { request } from './request';
import { toExportParams } from './toExportParams';

/** The export member of the client. */
export type ExportMethods = {
  /**
   * `GET /api/v1/puppets/{id}/export`: the runtime bundle zip; `{ format: 'baked', ... }` the baked sprite sheets
   * (sheets, `baked.json`, Phaser/Aseprite/Godot companions, `importers/`).
   */
  exportBundle: (puppetId: string, q?: ExportQuery) => Promise<Uint8Array>;
};

/** Export calls over `opts`. */
export function exportMethods(opts: ClientOptions): ExportMethods {
  return {
    exportBundle: async (id, q) => (await request<Uint8Array>(opts, {
      method: 'GET', path: fillPath('/api/v1/puppets/{id}/export', { id }), query: toExportParams(q), accept: 'bytes',
    })).value,
  };
}
